import React from "react";
import { Alert, Box, Container, IconButton, Paper, Snackbar, Stack, TextField, TextareaAutosize, Tooltip, Typography } from "@mui/material";

import { useOutletContext, useNavigate } from 'react-router-dom';

import VeryEditor from "../common/EditorVery/VeryEditor2";
import Service from "../../util/Service";
import { Save } from "@mui/icons-material";
import RulesPopover from "../page/portal/user/RulesPopover";

export default function ProjectForm(props) {
    const { projeto, setEdicao, action } = props;
    const { update } = useOutletContext();
    const navigate = useNavigate();

    const [html, setHtml] = React.useState('');
    const [nome, setNome] = React.useState('');
    const [descricao, setDescricao] = React.useState('');
    const [open, setOpen] = React.useState(false);
    const [msg, setMsg]=React.useState({
        severity: "success",
        txt: 'Ok!'
    })
    const [regra, setRegra] = React.useState('');
    const ref = React.useRef();

    React.useEffect(() => {
        update({
            title: {
                variant: 'h6',
                txt: 'Novo Projeto'
            },
            actions: []
        })
    }, []);

    React.useEffect(() => {
        if (projeto) {
            console.log('???')
            update({
                title: {
                    variant: 'h6',
                    txt: 'Edição ' + projeto.nome
                },
                actions: []
            })
            setNome(projeto.nome)
            setDescricao(projeto.descricao)
            setRegra(projeto.rule?projeto.rule:'');
            setHtml(projeto.pagina)
        }
    }, [projeto]);

    React.useEffect(() => {
        if (projeto) {
            if(projeto.isRedmine === true) {
                update({
                    actions: [
                        {
                            nome: 'Voltar',
                            ac: ()=>setEdicao(false)
                        },
                    ]
                })
            }else{   
                update({
                    save: {
                        tip: 'Atualizar Projeto',
                        ac: handleAtualizar
                    }
                })
            }
        } else {
            update({
                save: {
                    tip: 'Salvar projeto e criar Kanban',
                    ac: handleSalva
                }
            })
        }
    }, [nome, descricao, html]);

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpen(false);
    };

    function handleSalva() {
        const h = ref.current && ref.current.getHtml();
        const dado = {
            nome: nome,
            descricao: descricao,
            pagina: h
        }

        Service.POST('/api/security/projeto', dado).then(r => {
            if (r.success) {
                navigate('/project/pagina/' + r.id)
            } else {
                alert(r.msg);
                navigate('/login');
            }
        });
    }
    function handleSalvaHtml() {
        const html = ref.current.getHtml();

        
        if( projeto.isRedmine === true){
            let dado = {
                id:        projeto.id,
                nome:      projeto.nome,
                titulo:    'Redmine',
                descricao: projeto.descricao,
                pagina: html,
            }
            Service.POST("/api/security/paginaHtml", dado).then(r => {
                console.log(r);
                if(r){
                    setOpen(true);
                    if(action)action({
                        ...projeto,
                        pagina: r.pagina
                    });
                    setMsg({
                        severity: "success",
                        txt: 'Salvo com sucesso!'
                    })
                }
            })
        }else{   
            let dado = {
                id: projeto.id,
                nome: nome,
                descricao: descricao,
                pagina: html,
                rules: ['paginaPessoal']
            }
            Service.POST('/api/security/projeto/update', dado).then(r => {
                console.log(r);
                if (r.success) {
                    setOpen(true);
                    if(action)action(r.dado);
                    setMsg({
                        severity: "success",
                        txt: 'Salvo com sucesso!'
                    })
                } else {
                    setOpen(true);
                    setMsg({
                        severity: "warging",
                        txt: r.msg
                    })
                }
            });
        }
    }
    function handleAtualizar() {
        const h = ref.current.getHtml();
        console.log("regra -->", regra );
        const dado = {
            id: projeto.id,
            nome: nome,
            descricao: descricao,
            pagina: h,
            rule: regra,
        }
        console.log("-->", dado);

        Service.POST('/api/security/projeto/update', dado).then(r => {
            console.log(r);
            if (r.success) {
                if (action) action(r.dado);
                else navigate('/project')
            } else {
                alert(r.msg)
            }
        });
    }
    function changeRegra(regra){
        console.log("changeRegra: ", regra.nome );
        setRegra(regra.nome);
        const dado = {
            id: projeto.id,
            rule: regra.nome,
        }
        console.log("-->", dado);

        Service.POST('/api/security/projeto/updateRegra', dado).then(r => {
            console.log(r);
            if (r.success) {
                setOpen(true);
                setMsg({
                    severity: 'success',
                    txt:"Salvo com sucesso."
                })
            } else {
                alert(r.msg)
            }
        });
    }
    return (
        <div>
            <Paper sx={{ mt: projeto ? 0 : 2, padding: '16px' }}>
                <Stack spacing={2}>

                    <Stack direction="row" spacing={1}>
                        <TextField label="Nome" variant="outlined" size="small"
                            value={nome} onChange={(e) => setNome(e.target.value)}
                            disabled={projeto && projeto.isRedmine === true}
                            fullWidth
                            helperText="Nome para identificação unica do projeto"
                        />
                        {projeto && 
                        <RulesPopover action={changeRegra} showTxt={true} regra={regra}/>
                        }
                    </Stack>

                    <div style={{ width: '100%' }}>
                        <Typography>Descrição</Typography>
                        <TextareaAutosize
                            minRows={3}
                            style={{ width: '100%' }}
                            value={descricao} onChange={(e) => setDescricao(e.target.value)}
                            disabled={projeto && projeto.isRedmine === true}
                        />
                        <span className="pd-FormHelperText-root">Descrição resumida do projeto</span>
                    </div>
                    <Typography>Pagina do projeto</Typography>
                    {!projeto && <Box component="section" sx={{ p: 2, border: '1px solid grey' }}>
                        <Typography align="center" variant="h4">
                            Projeto para controle e acompanhamento de atividade.
                        </Typography>
                        <Typography variant="body1">
                            Todo projeto contem uma pagina informativa e de ações rápidas para facilitar as ativides. 
                            Após criar o projeto fique a vontade para customizar e montar a pagina de acordo com as necessidades do projeto. 
                        </Typography>
                    </Box> 
                    }
                    {projeto && <VeryEditor
                        html={projeto.pagina}
                        // setHtml={setHtml} 
                        ref={ref}
                        action={
                            <Tooltip title="Salvar pagina">
                                <IconButton aria-label="edit" color="primary"
                                    onClick={handleSalvaHtml}
                                >
                                    <Save />
                                </IconButton>
                            </Tooltip>
                        }
                        saveAction={handleSalvaHtml}
                    />}
                </Stack>
            </Paper>
            <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
                <Alert
                    onClose={handleClose}
                    severity={msg.severity}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                    {msg.txt}
                </Alert>
            </Snackbar>
        </div>
    )
}

